import BodyText from "components/Typography/BodyText"
import styled from "styled-components"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

const ContentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
`

const Image = styled.img`
  width: 36px;
  height: 36px;
`

interface CellLogoProps {
  title?: string
  image?: string
}

export const CellLogo = (props: CellLogoProps) => {
  const { title, image } = props

  return (
    <ContentColumn>
      <ContentRow>
        {image && <Image src={image} alt={`Logo do produto ${title}`} />}
        {title && (
          <BodyText size="small" weight="semi-bold">
            {title}
          </BodyText>
        )}
      </ContentRow>
    </ContentColumn>
  )
}
